import EastIcon from "@mui/icons-material/East";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  Modal,
  OutlinedInput,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { AiFillStar } from "react-icons/ai";
import { toast } from "react-toastify";
import Search from "../assets/search.png";
import SearchModal from "../helpercomponents/searchModal";
import SourcesLink from "../helpercomponents/sourcesLink";
import appstore from "../store/appstore";
import Navbar from "./navbar";
import Subscribing from "./subscribing";

const Sources = () => {
  const { isSubscribed } = appstore();
  const [isMobileview, setIsMobileView] = useState(false);
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [recommentModal, setRecommentModal] = useState(false);
  const [currentButton, setCurrentButton] = useState("All");
  const [currentShort, setShortFilter] = useState("Latest");
  const [feedback, setFeedback] = useState("");
  const [allSources, setAllsources] = useState([]);
  const [unfilteredSources, setUnfilteredSources] = useState([]);
  const [searchBoxvalue, setSearchBoxvalue] = useState("");
  const [allfilter, seAllfilter] = useState([]);
  const handlesearch = async (e) => {
    const newArray = [];
    setSearchBoxvalue(e);
    if (!e) {
      setAllsources(unfilteredSources);
      return;
    }
    unfilteredSources.map((el) => {
      if (el.url.includes(e)) {
        newArray.push(el);
      }
    });
    setAllsources(newArray);
  };
  const handleTagSearch = (button) => {
    // console.log("unfilteredSources", unfilteredSources);
    if (button == "All") {
      setAllsources(unfilteredSources);
      setCurrentButton("All");

      return;
    }
    let newSource = [];
    if (isSubscribed) {
      let newArray = [...unfilteredSources];
      newArray?.map((el, inx) => {
        if (el.tags.includes(button)) {
          newSource.push(el);
        }
      });
    } else {
      let newArray = [...unfilteredSources];
      newArray?.map((el, inx) => {
        if (inx <= 3) {
          if (el.tags.includes(button)) {
            newSource.push(el);
          }
        }
      });
    }
    setAllsources(newSource);
    setCurrentButton(button);
  };
  const fetchNewsLetter = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/sources",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await axios.request(config);
    setAllsources(response?.data);
    setUnfilteredSources(response?.data);
    let tagsArray = ["All"];
    response.data.map((el) => {
      tagsArray = [...tagsArray, ...JSON.parse(el.tags || [])];
    });
    seAllfilter([...new Set(tagsArray)]);
  };
  const handleSubmitReview = async () => {
    if (rating <= 0) {
      toast.error("Please fill the rating !");
      return;
    }
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/feedback",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email: localStorage.getItem("isSubscribed"),
        raitings: rating,
        message: feedback,
      },
    };
    try {
      const response = await axios.request(config);
      toast.success("Review submit !", { autoClose: 2000 });
      setRecommentModal(false);
      setFeedback("");
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  // console.log("allfilter", allfilter);
  React.useEffect(() => {
    if (window && window.innerWidth) {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
    const updateScreenWidth = () => {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };
    fetchNewsLetter();
    window.addEventListener("resize", updateScreenWidth);

    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  return (
    <>
      {" "}
      <Navbar />
      <Box style={{ background: "#fafafa", width: "100%" }}>
        {" "}
        <SearchModal
          title={"Search for Sources"}
          setOpen={setOpen}
          open={open}
          handlesearch={handlesearch}
          searchBoxvalue={searchBoxvalue}
        />
        <Box
          paddingLeft={"5%"}
          width={"90%"}
          display={isMobileview ? "none" : "flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box marginTop={"10px"} marginBottom={"35px"}>
            <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
              <OutlinedInput
                type={"text"}
                placeholder="Search"
                style={{
                  width: "351px",
                  borderRadius: "35px",
                  background: "#EDEDED",
                  border: "none",
                }}
                focused={false}
                onChange={(e) => {
                  handlesearch(e.target.value);
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={"display the password"}
                      style={{ background: "#C789E4", color: "white" }}
                      edge="end"
                    >
                      <EastIcon style={{ padding: "5px" }} />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Box>
          {/* <Box display={"flex"} gap={"8px"}>
            {["Latest", "Oldest"].map((el) => {
              return (
                <Button
                  className="item"
                  style={{
                    textTransform: "none",
                    // background: "#F5EAFA",
                    // color: "#C789E4",
                    // height: "35px",
                  }}
                  sx={{
                    background: currentShort == el ? "#F5EAFA" : "",
                    color: currentShort == el ? "#C789E4" : "grey",
                  }}
                  onClick={() => {
                    setShortFilter(el);
                  }}
                  disableElevation
                >
                  {el}
                </Button>
              );
            })}
          </Box> */}
        </Box>
        <Box
          display={isMobileview ? "flex" : "none"}
          // border={"1px solid red"}
          height={"53px"}
          fontSize={"22px"}
          paddingLeft={"5%"}
          paddingRight={"5%"}
          marginTop={"3%"}
          // boxShadow={1}
          fontWeight={500}
          justifyContent={"space-between"}
          position={"relative"}
        >
          <Box
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "50%",
              height: "1.5px",
              background: "linear-gradient(167deg, #ffffff, #eec9ff)",
            }}
          ></Box>
          <Box
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              width: "50%",
              height: "1.5px",
              background: "linear-gradient(244deg, #ffffff, #eec9ff)",
            }}
          ></Box>
          Sources Respository{" "}
          <img
            src={Search}
            style={{ cursor: "pointer" }}
            width={"24px"}
            height={"24px"}
            onClick={() => {
              setOpen(true);
            }}
          />
        </Box>
        {/* <Box className="wrapper" marginLeft={isMobileview ? "0%" : "5%"}> */}
        <Box
          // value={allfilter}
          color="info"
          // onChange={(asd, newFormats) => {
          //   seAllfilter(newFormats);
          // }}
          style={{
            overflowX: "scroll",
            // overflow: "auto",
            marginLeft: "4%",

            whiteSpace: "nowrap",
            width: "91%",
            padding: "10px",
          }}
          aria-label="Delivery Schedule"
          className="items"
          // style={{ display: "inline-flex" }}
        >
          {allfilter.map((el) => {
            return (
              <Button
                className="item"
                style={{
                  marginRight: "5%",
                  height: "35px",
                }}
                sx={{
                  background: currentButton == el ? "#F5EAFA" : "",
                  color: currentButton == el ? "#C789E4" : "grey",
                }}
                onClick={() => {
                  handleTagSearch(el);
                }}
                disableElevation
              >
                {el}
              </Button>
            );
          })}

          {/* <Button
            style={{
              marginRight: "5%",
              height: "35px",
            }}
            sx={{
              // "&.Mui-selected": {
              background: currentButton == "Neurology" ? "#F5EAFA" : "",
              // border:"1px solid grey",
              color: currentButton == "Neurology" ? "#C789E4" : "grey",
              // },
            }}
            onClick={() => {
              setCurrentButton("Neurology");
            }}
            // className="item"
          >
            Neurology
          </Button>
          <Button
            value="Cardiology"
            style={{
              marginRight: "5%",
              height: "35px",
            }}
            sx={{
              // "&.Mui-selected": {
              background: currentButton == "Cardiology" ? "#F5EAFA" : "",
              // border:"1px solid grey",
              color: currentButton == "Cardiology" ? "#C789E4" : "grey",
              // },
            }}
            onClick={() => {
              setCurrentButton("Cardiology");
            }}
            // className="item"
          >
            Cardiology
          </Button>
          <Button
            value="Urlogy"
            style={{
              marginRight: "5%",
              height: "35px",
            }}
            sx={{
              // "&.Mui-selected": {
              background: currentButton == "Urlogy" ? "#F5EAFA" : "",
              // border:"1px solid grey",
              color: currentButton == "Urlogy" ? "#C789E4" : "grey",
              // },
            }}
            onClick={() => {
              setCurrentButton("Urlogy");
            }}
            // className="item"
          >
            Urlogy
          </Button>
          <Button
            value="Oncology"
            style={{
              marginRight: "5%",
              height: "35px",
            }}
            sx={{
              // "&.Mui-selected": {
              background: currentButton == "Oncology" ? "#F5EAFA" : "",
              // border:"1px solid grey",
              color: currentButton == "Oncology" ? "#C789E4" : "grey",
              // },
            }}
            onClick={() => {
              setCurrentButton("Oncology");
            }}
            disableElevation
            // className="item"
          >
            Oncology
          </Button>
          <Button
            value="Psychiatry"
            style={{
              marginRight: "5%",
              height: "35px",
            }}
            sx={{
              // "&.Mui-selected": {
              background: currentButton == "Psychiatry" ? "#F5EAFA" : "",
              // border:"1px solid grey",
              color: currentButton == "Psychiatry" ? "#C789E4" : "grey",
              // },
            }}
            onClick={() => {
              setCurrentButton("Psychiatry");
            }}
            className="item"
          >
            Psychiatry
          </Button> */}
        </Box>
        {isSubscribed ? (
          <Box sx={{ width: "94%", paddingLeft: "5%", marginBottom: "40px" }}>
            {currentShort == "Latest"
              ? allSources
                  .sort(
                    (a, b) => new Date(a?.created_at) - new Date(b?.created_at)
                  )
                  .map((el) => {
                    return <SourcesLink link={el?.url} />;
                  })
              : allSources
                  .sort(
                    (b, a) => new Date(a?.created_at) - new Date(b?.created_at)
                  )
                  .map((el) => {
                    return <SourcesLink link={el?.url} />;
                  })}
          </Box>
        ) : (
          <Box sx={{ width: "94%", paddingLeft: "5%" }}>
            {currentShort == "Latest"
              ? allSources
                  .sort(
                    (a, b) => new Date(a?.created_at) - new Date(b?.created_at)
                  )

                  .map((el, inx) => {
                    if (inx <= 3) {
                      return <SourcesLink link={el?.url} />;
                    }
                  })
              : allSources
                  .sort(
                    (b, a) => new Date(a?.created_at) - new Date(b?.created_at)
                  )
                  .map((el, inx) => {
                    if (inx <= 3) {
                      return <SourcesLink link={el?.url} />;
                    }
                  })}
          </Box>
        )}
        <Button
          // display={isSubscribed ? "block" : "none"}
          variant="contained"
          size={isMobileview ? "small" : "medium"}
          style={{
            display: isSubscribed ? "block" : "none",
            position: "fixed",
            bottom: "8%",
            right: "5%",
          }}
          onClick={() => {
            setRecommentModal(true);
          }}
        >
          Recommend Us{" "}
        </Button>
        <Subscribing />
        <Modal
          open={recommentModal}
          onClose={() => {
            setRecommentModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: isMobileview ? "80%" : "50%",
              bgcolor: "background.paper",
              p: isMobileview ? 2 : 4,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              borderRadius: isMobileview ? "10px" : "20px",
            }}
          >
            <Box
              margin={"auto"}
              fontSize={isMobileview ? "16px" : "22px"}
              fontWeight={600}
            >
              {" "}
              Was the content relevant to your search?
            </Box>
            <Box
              margin={"auto"}
              textAlign={"center"}
              fontSize={isMobileview ? "12px" : "16px"}
              color={"#9F9BA1"}
            >
              {" "}
              Share your suggestions for topics or discussions that matter most
              to you. Your insights help us craft content tailored to your
              professional needs and interests
            </Box>
            <Box
              display={"flex"}
              width={isMobileview ? "55%" : "40%"}
              alignItems={"center"}
              margin={"auto"}
              justifyContent={"space-around"}
              // border={'1px solid red'}
              gap={"5%"}
            >
              <AiFillStar
                onClick={() => {
                  if (rating == 1) {
                    setRating(0);
                  } else {
                    setRating(1);
                  }
                }}
                fontSize={`${rating >= 1 ? "34px" : "28px"}`}
                color={`${rating >= 1 ? "#ffb851" : "#cbcbcb"}`}
              />
              <AiFillStar
                onClick={() => {
                  setRating(2);
                }}
                fontSize={`${rating >= 2 ? "34px" : "28px"}`}
                color={`${rating >= 2 ? "#ffb851" : "#cbcbcb"}`}
              />
              <AiFillStar
                onClick={() => {
                  setRating(3);
                }}
                fontSize={`${rating >= 3 ? "34px" : "28px"}`}
                color={`${rating >= 3 ? "#ffb851" : "#cbcbcb"}`}
              />
              <AiFillStar
                onClick={() => {
                  setRating(4);
                }}
                fontSize={`${rating >= 4 ? "34px" : "28px"}`}
                color={`${rating >= 4 ? "#ffb851" : "#cbcbcb"}`}
              />
              <AiFillStar
                onClick={() => {
                  setRating(5);
                }}
                fontSize={`${rating >= 5 ? "34px" : "28px"}`}
                color={`${rating >= 5 ? "#ffb851" : "#cbcbcb"}`}
              />
            </Box>
            <textarea
              style={{
                borderRadius: "12px",
                height: isMobileview ? "100px" : "140px",
                border: "1px solid #d5d9d5",
                padding: "15px",
                fontFamily: "Instrument Sans",
              }}
              placeholder="Add Comment..."
              onChange={(e) => {
                setFeedback(e?.target?.value);
              }}
            />
            <Box sx={{ display: "flex", gap: "20px", margin: "auto" }}>
              <Button
                variant="contained"
                onClick={() => {
                  handleSubmitReview();
                }}
              >
                Submit{" "}
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default Sources;
